// extracted by mini-css-extract-plugin
export var badgeTextContainer = "_62-2";
export var blackBorderOnHover = "_62-7";
export var cell = "_62-6";
export var cellContainer = "_62-3";
export var checked = "_62-8";
export var disabled = "_62-5";
export var featuredIconCellContainer = "_62-9";
export var featuredIconTextContainer = "_62-b";
export var featuredIconWrapper = "_62-a";
export var noBorder = "_62-c";
export var orangeSelectedRow = "_bs-3";
export var overflowableText = "_62-0";
export var overflowableTextContainer = "_62-1";
export var row = "_63-0";
export var rowCheckboxCell = "_62-4";
export var selectableTable = "_bs-2";